/**
 * Event Emitter
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

let isFunction = (obj) => typeof obj === 'function' || false

export default class EventEmitter {
  constructor () {
    this.listeners = new Map()
  }

  addEventListener (name, callback) {
    this.listeners.has(name) || this.listeners.set(name, [])
    this.listeners.get(name).push(callback)
  }

  removeListener (name, callback) {
    let listeners = this.listeners.get(name)
    let index

    if (listeners && listeners.length) {
      index = listeners.reduce((previous, listener, index) => {
        let isCallback = (isFunction(listener) && listener === callback)
        previous = isCallback ? index : previous
        return previous
      }, -1)

      if (index > -1) {
        listeners.splice(index, 1)
        this.listeners.set(name, listeners)
        return true
      }
    }
    return false
  }

  dispatchEvent (name, ...args) {
    let listeners = this.listeners.get(name)

    if (listeners && listeners.length) {
      listeners.forEach((listener) => {
        listener(...args)
      })

      return true
    }

    return false
  }
}
